import config from 'baseConfig/pg/v2/settlements';

import {
  STANDARD,
  INSTANT,
  VENDOR,
} from 'baseConfig/pg/v2/constants';

export default {
  [STANDARD]: {
    TABLE_COLUMNS: [...config[STANDARD]?.TABLE_COLUMNS],
    FILTER_ITEMS: {...config[STANDARD]?.FILTER_ITEMS},
    SEARCH_ITEMS: [...config[STANDARD]?.SEARCH_ITEMS],
  },
  [INSTANT]: {
    TABLE_COLUMNS: [...config[INSTANT]?.TABLE_COLUMNS],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  },
  [VENDOR]: {
    TABLE_COLUMNS: [...config[VENDOR]?.TABLE_COLUMNS],
    FILTER_ITEMS: {...config[VENDOR]?.FILTER_ITEMS},
    SEARCH_ITEMS: [...config[VENDOR]?.SEARCH_ITEMS],
  },
  VENDOR_FOR_SETTLEMENT_V2_UI: {
    TABLE_COLUMNS: [...config['VENDOR_FOR_SETTLEMENT_V2_UI']?.TABLE_COLUMNS],
    FILTER_ITEMS: {},
    SEARCH_ITEMS: [],
  }
};
